<template>
    <div 
        ref="settings"
        class="settings row"
    >
        <div class="settings-header col-12">
            {{title}}
            
            <tooltip-circle 
                    v-if="tooltip"
                    v-bind:html="true"
                    v-bind:text="tooltip"
            ></tooltip-circle>
        </div>

        <div class="settings-body col-12">
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    
    import TooltipCircle from "../../../../Components/Util/TooltipCircle.vue";
    
    const regions = {
        left: 'left'
    };
    
    const regionSelectors = {
        left: '.template-manager-left',
        right: '.template-manager-right'
    };
    
    export {
        regions
    }
    
    export default {
        name: "settings",
        components: {
            TooltipCircle
        },
        mounted() {
            if(this.hasTarget) {
                const settings = $(this.$refs.settings);
                const target = $(this.target);

                settings.appendTo(target);
            }
        },
        computed: {
            target(){
                const vm = this;
                
                //We should prefer a more explicit selector over our region
                if(vm.targetSelector){
                    return vm.targetSelector;
                }
                
                if(vm.region){
                    return regionSelectors[vm.region];
                }
            },
            hasTarget() {
                return this.target !== undefined;
            }
        },
        props: {
            region: {
                type: String,
                required: false,
                validate(value){
                    return Object.values(regions).indexOf(value) !== -1;
                }
            },
            title: {
                type: String,
                required: true
            },
            tooltip: {
                type: String,
                required: false
            },
            targetSelector: {
                type: String,
                required: false
            }
        }
    };
</script>

<style scoped lang="sass" src="../../Style/template-settings.scss">
    
</style>
